import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import GiGLife from "./pages/GiGLife";
import LoginPage from "./pages/LoginPage";
import { AuthProvider, useAuth } from "./components/AuthContext";

const AppShell = () => {
  const { user } = useAuth();
  if (user === null) {
    // initial /auth/me probe in flight — show a neutral loader
    return (
      <div className="min-h-screen w-full flex items-center justify-center text-neutral-500 text-xs uppercase tracking-widest">
        Chargement…
      </div>
    );
  }
  if (user === false) return <LoginPage />;
  return (
    <Routes>
      <Route path="/" element={<GiGLife />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-black text-white">
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
